'use client';

import React, { useEffect, useRef } from 'react';

export default function CustomCursor() {
  const trailsRef = useRef<HTMLDivElement[]>([]);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      const dot = document.createElement('div');
      dot.style.cssText = `
        position: fixed;
        left: ${e.clientX - 3}px;
        top: ${e.clientY - 3}px;
        width: 6px;
        height: 6px;
        background: #ff1a1a;
        border-radius: 50%;
        pointer-events: none;
        z-index: 99999;
        animation: cursor-trail-fade 0.5s ease forwards;
      `;
      document.body.appendChild(dot);
      setTimeout(() => {
        if (dot.parentNode) dot.parentNode.removeChild(dot);
      }, 500);
    };

    let throttle = false;
    const throttledMove = (e: MouseEvent) => {
      if (!throttle) {
        throttle = true;
        handleMouseMove(e);
        setTimeout(() => {
          throttle = false;
        }, 60);
      }
    };

    document.addEventListener('mousemove', throttledMove);
    return () => document.removeEventListener('mousemove', throttledMove);
  }, []);

  return null;
}
